import React, { useState, useCallback, useRef, useEffect } from "react";
import { Modal, Input, message, Select, Form } from "antd";
import ReactFlow, {
  addEdge,
  Background,
  Controls,
  MiniMap,
  useNodesState,
  useEdgesState,
  Panel
} from "reactflow";
import "reactflow/dist/style.css";
import axios from '../../services/axios';

const { Option } = Select;

const initialNodes = [
  { id: "1", data: { label: "Draughtsman" }, position: { x: 50, y: 50 }, style: { background: "#1E40AF", color: "white", padding: 10 } },
  { id: "2", data: { label: "Design Manager" }, position: { x: 50, y: 150 }, style: { background: "#1E40AF", color: "white", padding: 10 } },
  { id: "3", data: { label: "Project Manager" }, position: { x: 50, y: 250 }, style: { background: "#1E40AF", color: "white", padding: 10 } },
  { id: "4", data: { label: "Document Controller" }, position: { x: 450, y: 50 }, style: { background: "#DC2626", color: "white", padding: 10 } }
];

const initialEdges = [
  { id: "e1-2", source: "1", target: "2" ,
    markerEnd: { type: "arrowclosed", color: "#000000" }, 
    style: { stroke: "#000000", strokeWidth: 2 }
  },
  { id: "e2-3", source: "2", target: "3", label: "YES",
    markerEnd: { type: "arrowclosed", color: "#000000" }, 
    style: { stroke: "#000000", strokeWidth: 2 }
   },
  { id: "e3-4", source: "3", target: "4",
    markerEnd: { type: "arrowclosed", color: "#000000" }, 
    style: { stroke: "#000000", strokeWidth: 2 }
   }
];


const nodeTypes = [
  { type: "Process", style: { background: "#1E40AF", color: "white", padding: 10 } },
  { type: "Decision", style: { background: "#DC2626", color: "white", padding: 10 } },
  { type: "Action", style: { background: "#FACC15", color: "black", padding: 10 } },
  { type: "Review", style: { background: "pink", color: "black", padding: 10 } }
];

const WorkflowPage = () => {
  const reactFlowWrapper = useRef(null);
  const [form] = Form.useForm();
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [nodeName, setNodeName] = useState("");
  const [selectedNode, setSelectedNode] = useState(null);
  const [roles, setRoles] = useState([]);
  const [connecting, setConnecting] = useState(false);
  const [selectedNodeType, setSelectedNodeType] = useState(nodeTypes[0]);
  const [isSaveModalVisible, setIsSaveModalVisible] = useState(false);
  const [documentType, setDocumentType] = useState([]);
  const [documentCategory, setDocumentCategory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = localStorage.getItem('user');
  const [assignedProjects, setAssignedProjects] = useState([]);
  const documentTypes = [
    { label: "Tender (TDR)", value: "Tender (TDR)" },
    { label: "Issued for Construction (IFC)", value: "Issued for Construction (IFC)" },
    { label: "Construction (CNS)", value: "Construction (CNS)" },
    { label: "As-Built (ASB)", value: "As-Built (ASB)" },
    { label: "Photo (PIC)", value: "Photo (PIC)" },
    { label: "Commercial (COM)", value: "Commercial (COM)" },
    { label: "Contract (CTR)", value: "Contract (CTR)" },
    { label: "Project Close-out (PXX)", value: "Project Close-out (PXX)" },
    { label: "Change Management (CHM)", value: "Change Management (CHM)" }
  ];
  
  const documentCategories = [
    { label: "Drawing (DWG)", value: "Drawing (DWG)" },
    { label: "Specification (SPF)", value: "Specification (SPF)" },
    { label: "Material Approval Submittal (MAS)", value: "Material Approval Submittal (MAS)" },
    { label: "Material Inspection Report (MIR)", value: "Material Inspection Report (MIR)" },
    { label: "Installation Inspection Report (IIR)", value: "Installation Inspection Report (IIR)" },
    { label: "Request for Information (RFI)", value: "Request for Information (RFI)" },
    { label: "Health, Safety & Environment (HSE)", value: "Health, Safety & Environment (HSE)" },
    { label: "Non-Conformance Report (NCR)", value: "Non-Conformance Report (NCR)" },
    { label: "Site Observation (SOB)", value: "Site Observation (SOB)" },
    { label: "Interim Payment Application (IPA)", value: "Interim Payment Application (IPA)" },
    { label: "Interim Payment Certificate (IPC)", value: "Interim Payment Certificate (IPC)" },
    { label: "Payment Receipt (PYR)", value: "Payment Receipt (PYR)" },
    { label: "Method Statement (MST)", value: "Method Statement (MST)" },
    { label: "Inspection & Test Plan (ITP)", value: "Inspection & Test Plan (ITP)" },
    { label: "Tender Drawing (DWG)", value: "Tender Drawing (DWG)" },
    { label: "Tender Specification (TSPF)", value: "Tender Specification (TSPF)" },
    { label: "Other Tender Documents (TOD)", value: "Other Tender Documents (TOD)" },
    { label: "Letter of Award (LOA)", value: "Letter of Award (LOA)" },
    { label: "Performance Bond (PBG)", value: "Performance Bond (PBG)" },
    { label: "Advance Payment Bond (ABG)", value: "Advance Payment Bond (ABG)" },
    { label: "Insurance (INS)", value: "Insurance (INS)" },
    { label: "Current Agreement (CAG)", value: "Current Agreement (CAG)" },
    { label: "IFC Drawing (DWG)", value: "IFC Drawing (DWG)" },
    { label: "IFC Specification (ISPF)", value: "IFC Specification (ISPF)" },
    { label: "Shop Drawing (DWG)", value: "Shop Drawing (DWG)" },
    { label: "Pre Qualification Document (PQD)", value: "Pre Qualification Document (PQD)" },
    { label: "Project Schedule (PRM)", value: "Project Schedule (PRM)" },
    { label: "Authority Approvals (AAP)", value: "Authority Approvals (AAP)" },
    { label: "Correspondences (LTR)", value: "Correspondences (LTR)" },
    { label: "Minutes of Meeting (MOM)", value: "Minutes of Meeting (MOM)" },
    { label: "Transmittals (TRN)", value: "Transmittals (TRN)" },
    { label: "Final Payment Application (FPA)", value: "Final Payment Application (FPA)" },
    { label: "Final Payment Certification (fpc)", value: "Final Payment Certification (fpc)" },
    { label: "Site Photos (SPO)", value: "Site Photos (SPO)" },
    { label: "As-Built Drawing (ASB)", value: "As-Built Drawing (ASB)" },
    { label: "Operation & Maintenance Manuals (ORM)", value: "Operation & Maintenance Manuals (ORM)" },
    { label: "Spares (SPR)", value: "Spares (SPR)" },
    { label: "Warranty (WTY)", value: "Warranty (WTY)" },
    { label: "Taking-Over Certification (TOC)", value: "Taking-Over Certification (TOC)" },
    { label: "Performance Certificate (PRC)", value: "Performance Certificate (PRC)" },
    { label: "Engineer's Instruction (EIN)", value: "Engineer's Instruction (EIN)" },
    { label: "Variation Order Request / Change Request (VAR)", value: "Variation Order Request / Change Request (VAR)" },
    { label: "Impact Assessment (IMA)", value: "Impact Assessment (IMA)" },
    { label: "Updated Project Document (UPD)", value: "Updated Project Document (UPD)" },
    { label: "Change Log (CLO)", value: "Change Log (CLO)" },
    { label: "Change Control Meeting Minutes (CMO)", value: "Change Control Meeting Minutes (CMO)" },
    { label: "Claim (CLM)", value: "Claim (CLM)" },
    { label: "Variation-to-Contract (VTC)", value: "Variation-to-Contract (VTC)" },
    { label: "Change Order (CHO)", value: "Change Order (CHO)" },
  ];


  const onConnect = useCallback((params) => {
    let edgeLabel = "";
  
    Modal.confirm({
      title: "Enter Edge Label",
      content: (
        <Input
          placeholder="e.g., YES, NO, NEXT"
          onChange={(e) => {
            edgeLabel = e.target.value;
          }}
        />
      ),
      okText: "Add Edge",
      cancelText: "Cancel",
      onOk() {
        const edgeId = `e${params.source}-${params.target}`;
        setEdges((eds) =>
          addEdge(
            {
              ...params,
              id: edgeId,
              label: edgeLabel,
              markerEnd: { type: "arrowclosed", color: "#000000" },
              style: { stroke: "#000000", strokeWidth: 2 },
            },
            eds
          )
        );
      },
    });
  }, [setEdges]);

  // Handle drag over for new nodes
  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  // Handle drop for new nodes
  const onDrop = useCallback(
    (event) => {
      event.preventDefault();

      const type = event.dataTransfer.getData('application/reactflow');
      
      // Check if the dropped element is valid
      if (typeof type === 'undefined' || !type) {
        return;
      }

      // Get the position where we drop
      const position = reactFlowInstance.screenToFlowPosition({
        x: event.clientX,
        y: event.clientY,
      });
      
      // Create the new node
      const newNode = {
        id: `${Date.now()}`,
        type: 'default',
        position,
        data: { label: nodeName || `New ${type}` },
        style: selectedNodeType.style,
      };

      // Add the new node
      setNodes((nds) => nds.concat(newNode));
      setNodeName("");
    },
    [reactFlowInstance, nodeName, selectedNodeType, setNodes]
  );

  // Remove nodes and their connected edges
  const onNodesDelete = useCallback(
    (deleted) => {
      setEdges(
        edges.filter(
          (edge) => !deleted.some((node) => node.id === edge.source || node.id === edge.target)
        )
      );
    },
    [edges, setEdges]
  );

  // Handle node selection for editing
  const onNodeClick = useCallback((event, node) => {
    setSelectedNode(node);
  }, []);

  // Update selected node label
  const updateNodeLabel = () => {
    if (selectedNode && nodeName) {
      setNodes(nodes.map(node => 
        node.id === selectedNode.id 
          ? { ...node, data: { ...node.data, label: nodeName } } 
          : node
      ));
      setNodeName("");
      setSelectedNode(null);
    }
  };

  // Save workflow as JSON
  const saveWorkflow = () => {
    setIsSaveModalVisible(true);
    form.resetFields();
  };

  const getRoles = async () => {
    try {
      const res = await axios.get("get-all-roles");

      if (res && res.data && res.data.roles) {
        setRoles(res.data.roles);
      }

    } catch (err) {
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.status === 401) {
        message.error("User not authorised");
      } else {
        message.error("Something went wrong");
      }
    }
  };

  useEffect(() => {
    getRoles();
  }, []);

  const handleConfirmSave = async () => {
    try{
      const values = await form.validateFields();

      const user = localStorage.getItem('user');

      const flowData = { nodes, edges, user,
        documentType: values.documentType, projectName: values.projectName, documentCategory: values.documentCategory, workflowName: values.workflowName, workflowDescription: values.workflowDescription
      };
      setIsLoading(true);

      await axios.post("/save-workflow", flowData);
      message.success("Workflow saved successfully");
      setIsLoading(false);
      setIsSaveModalVisible(false);
    } catch (err) {
      setIsLoading(false);
          if (err.response && err.response.data && err.response.data.msg) {
            message.warning(err.response.data.msg);
          } else if (err.response && err.response.data && err.response.data.userName) {
            message.warning(err.response.data.userName[0]);
          } else if (err.response && err.response.status === 401) {
            message.error('User not authorised');
          } else {
            message.error('Something went wrong');
          }
        }
  }

  const downloadTemplate = () => {
    const flowData = { nodes, edges, documentType, documentCategory };

    const jsonString = JSON.stringify(flowData, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = 'workflow.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    message.success("Template downloaded successfully");
  };

  const loadWorkflow = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const flowData = JSON.parse(e.target.result);
          if (flowData.nodes && flowData.edges) {
            setNodes(flowData.nodes);
            setEdges(flowData.edges);
            message.success("Workflow Imported Successfully");
          }
        } catch (error) {
          message.error("Failed to import workflow file. Please check the format.");
        }
      };
      reader.readAsText(file);
    }
  };

  const clearWorkflow = () => {
    Modal.confirm({
      title: "Confirm Workflow Clear",
      content: "Are you sure you want to clear the entire workflow?",
      okText: "Yes, Clear",
      cancelText: "Cancel",
      onOk() {
        message.success("Workflow cleared successfully");
        setNodes([]);
        setEdges([]);
      },
    });
  };

  // Start with a template (your initial workflow)
  const useTemplate = () => {
    setNodes(initialNodes);
    setEdges(initialEdges);
    message.success("Template loaded successfully");
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get("/get-projects", { params: { user } });
         if (response.data.projects.length === 1) {
          form.setFieldsValue({
            projectName: response.data.projects[0].projectName
          });
        }
  
        setAssignedProjects(response.data.projects);
      } catch (error) {
        console.error("Error fetching assigned projects:", error);
      }
    };
    fetchProjects();
  }, [user, form]);

  return (
    <div className="relative flex-1 p-6 overflow-y-auto ml-7 mr-2  flex flex-col min-h-screen" style={{ height: 'calc(100vh - 64px)' }}>
      <div className="flex flex-1">
        {/* Sidebar */}
        <div className="w-64 bg-gray-200 p-4 flex flex-col">
          <h2 className="text-lg font-semibold mb-4">Workflow Tools</h2>
          
          {/* Node Type Selection */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Node Type</label>
            <select 
              className="w-full p-2 border rounded"
              value={selectedNodeType.type}
              onChange={(e) => {
                const selected = nodeTypes.find(type => type.type === e.target.value);
                setSelectedNodeType(selected || nodeTypes[0]);
              }}
            >
              {nodeTypes.map((type) => (
                <option key={type.type} value={type.type}>{type.type}</option>
              ))}
            </select>
          </div>
          
          {/* Node Name Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">
              {selectedNode ? 'Update Node Label' : 'New Node Label'}
            </label>
            {/* <select
              value={nodeName}
              onChange={(e) => setNodeName(e.target.value)}
              className="w-full p-2 border rounded"
            >
              <option value="">-- Select Role --</option>

              <option>Management</option>
              <option>Document Controller</option>
              <option>Project Manager</option>
              <option>Engineer</option>
              <option>Draughtsman</option>
              <option>Design Manager</option>
              <option>QAQC Manager</option>
              <option>Contract Manager</option>
              <option>Planning Engineer</option>
              <option>Quantity Surveyor</option>
              <option>Procurement Manager</option>
              <option>Health Safety & Environment Officer</option>
              <option>Site Engineer</option>
              <option>Site Administrator</option>
              <option>Supervisor</option>
              <option>Staff</option>

              <option>Consultant Management</option>
              <option>Consultant Draughtsman</option>
              <option>Consultant Design Manager</option>
              <option>Consultant Document Controller</option>
              <option>Consultant Project Manager</option>
              <option>Consultant Engineer</option>
              <option>Consultant QAQC Manager</option>
              <option>Consultant Contract Manager</option>
              <option>Consultant Planning Engineer</option>
              <option>Consultant Quantity Surveyor</option>
              <option>Consultant Procurement Manager</option>
              <option>Consultant Health Safety & Environment Officer</option>
              <option>Consultant Site Engineer</option>
              <option>Consultant Site Administrator</option>
              <option>Consultant Supervisor</option>
              <option>Consultant Staff</option>

              <option>Employer Management</option>
              <option>Employer Draughtsman</option>
              <option>Employer Document Controller</option>
              <option>Employer Project Manager</option>
              <option>Employer Engineer</option>
              <option>Employer Design Manager</option>
              <option>Employer QAQC Manager</option>
              <option>Employer Contract Manager</option>
              <option>Employer Planning Engineer</option>
              <option>Employer Quantity Surveyor</option>
              <option>Employer Procurement Manager</option>
              <option>Employer Health Safety & Environment Officer</option>
              <option>Employer Site Engineer</option>
              <option>Employer Supervisor</option>
              <option>Employer Site Administrator</option>
              <option>Employer Staff</option>

              <option>Subcontractor Management</option>
              <option>Subcontractor Draughtsman</option>
              <option>Subcontractor Document Controller</option>
              <option>Subcontractor Project Manager</option>
              <option>Subcontractor Design Manager</option>
              <option>Subcontractor QAQC Manager</option>
              <option>Subcontractor Contract Manager</option>
              <option>Subcontractor Planning Manager</option>
              <option>Subcontractor Quantity Surveyor</option>
              <option>Subcontractor Procurement Manager</option>
              <option>Subcontractor Health Safety & Environment Officer</option>
              <option>Subcontractor Engineer</option>
              <option>Subcontractor Site Administration</option>
              <option>Subcontractor Site Engineer</option>
              <option>Subcontractor Supervisor</option>
              <option>Subcontractor Staff</option>
            </select> */}

            <select
              value={nodeName}
              onChange={(e) => setNodeName(e.target.value)}
              className="w-full p-2 border rounded"
            >
              <option value="">-- Select Role --</option>

              {roles && roles.length > 0 &&
                roles.map((role) => (
                  <option key={role._id} value={role.role}>
                    {role.role}
                  </option>
                ))
              }

            </select>

            {selectedNode && (
              <button
                onClick={updateNodeLabel}
                className="mt-2 bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
              >
                Update
              </button>
            )}
          </div>
          
          {/* Draggable Node */}
          <div 
            className="mb-4 p-3 bg-white rounded shadow cursor-move border-2 border-dashed border-gray-400"
            draggable
            onDragStart={(event) => {
              event.dataTransfer.setData('application/reactflow', selectedNodeType.type);
            }}
          >
            Drag to add {selectedNodeType.type} node
          </div>
          
          {/* Workflow Actions */}
          <div className="mt-auto space-y-2">
            <button 
              onClick={saveWorkflow}
              className="w-full bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700"
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save Workflow'}
            </button>

            <button
              onClick={ downloadTemplate}
              className="w-full bg-yellow-600 text-white px-3 py-2 rounded hover:bg-yellow-700"
            >
              Download Workflow
            </button>
            
            <label className="block w-full bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 text-center cursor-pointer">
              Import From File
              <input 
                type="file" 
                accept=".json" 
                onChange={loadWorkflow} 
                className="hidden" 
              />
            </label>
            
            <button 
              onClick={clearWorkflow}
              className="w-full bg-red-600 text-white px-3 py-2 rounded hover:bg-red-700"
            >
              Clear Workflow
            </button>
            
            <button 
              onClick={useTemplate}
              className="w-full bg-purple-600 text-white px-3 py-2 rounded hover:bg-purple-700"
            >
              Use Template
            </button>
          </div>
        </div>
        
        
        <div ref={reactFlowWrapper} className="flex-1 h-full">
          <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={onConnect}
            onInit={setReactFlowInstance}
            onDrop={onDrop}
            onDragOver={onDragOver}
            onNodesDelete={onNodesDelete}
            onNodeClick={onNodeClick}
            onConnectStart={() => setConnecting(true)}
            onConnectEnd={() => setConnecting(false)}
            fitView
            deleteKeyCode={['Backspace', 'Delete']}
          >
            <Controls />
            <MiniMap />
            <Background variant="dots" gap={12} size={1} />
            <Panel position="top-right">
              <div className="bg-white p-2 rounded shadow">
                <p className="text-sm">
                  <strong>Tip:</strong> Connect nodes by dragging from one node's handle to another
                </p>
              </div>
            </Panel>
          </ReactFlow>
        </div>
      </div>

      {/* Save Workflow Modal */}
      <Modal
        title="Save Workflow"
        open={isSaveModalVisible}
        onOk={handleConfirmSave}
        onCancel={() => {
          setIsSaveModalVisible(false);
          form.resetFields();
        }}
        okText="Save"
        cancelText="Cancel"
        confirmLoading={isLoading}
      >
 
        <Form form={form} layout="vertical">
          <Form.Item
            name="projectName"
            label="Project Name"
            rules={[
              {
                required: true,
                message: 'Please select a project',
              },
            ]}
          >
            {/* {assignedProjects.length === 1 ? (
              <Input value={assignedProjects[0].projectName} disabled />
            ) : ( */}
              <Select placeholder="Select Project">
                {assignedProjects.map((proj) => (
                  <Option key={proj.projectName} value={proj.projectName}>
                    {proj.projectName}
                  </Option>
                ))}
              </Select>
            {/* )} */}
          </Form.Item>
          <Form.Item
            name="workflowName"
            label="Workflow Name"
            rules={[
              { 
                required: true, 
                message: 'Please enter workflow name' 
              }
            ]}
          >
          <Input placeholder="Enter name" />
          </Form.Item>

          <Form.Item
            name="workflowDescription"
            label="Workflow Description"
            rules={[
              { 
                required: true, 
                message: 'Please enter workflow description' 
              }
            ]}
          >
          <Input placeholder="Enter description" />
          </Form.Item>
          <Form.Item
            name="documentType"
            label="Document Type"
            rules={[
              { 
                required: true, 
                message: 'Please select at least one document type!' 
              }
            ]}
          >
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Select Document Type"
              options={documentTypes}
            />
          </Form.Item>
          
          <Form.Item
            name="documentCategory"
            label="Document Category"
            rules={[
              { 
                required: true, 
                message: 'Please select at least one document category!' 
              }
            ]}
          >
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Select Document Category"
              options={documentCategories}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default WorkflowPage;